import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export type ContentStrings = {
  [p: string]: string;
};

export const GET_CONTENT_STRING_SWR_KEY = 'GET_CONTENT_STRING_SWR_KEY';

export const getContentString = (
  contentKey: string,
  langCode: string,
): Promise<string> =>
  fetchFromOldApi(`/json/string/${contentKey}/${langCode}`).then((r) =>
    r.json(),
  );

export const useGetContentStrings = (
  args: {
    contentKeys: string[];
    langCode: string;
  },
  swrConfig?: SWRConfiguration<ContentStrings>,
): UseSWROutput<ContentStrings> => {
  return useSWR(
    [GET_CONTENT_STRING_SWR_KEY, args.contentKeys, args.langCode],
    ([_, contentKeys, langCode]) => {
      const keys = contentKeys as string[];

      return Promise.all(
        keys.map((key) => getContentString(key, langCode)),
      ).then((results) =>
        Object.fromEntries(keys.map((key, index) => [key, results[index]])),
      );
    },
    swrConfig,
  );
};
